import {TOGGLE_PANDA_BOX} from './constant';

export const togglePandaBox = projectId => ({
  type: TOGGLE_PANDA_BOX,
  payload: {
    projectId
  }
});
